import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { faHome } from "@fortawesome/pro-regular-svg-icons/faHome"
import { faCompass } from "@fortawesome/pro-regular-svg-icons/faCompass"
import { faCalendarWeek } from "@fortawesome/pro-regular-svg-icons/faCalendarWeek"
import { faList } from "@fortawesome/pro-regular-svg-icons/faList"
import { faCheckSquare } from "@fortawesome/pro-regular-svg-icons/faCheckSquare"
import { faInbox } from "@fortawesome/pro-regular-svg-icons/faInbox"
import { faPaperPlane } from "@fortawesome/pro-regular-svg-icons/faPaperPlane"
import { faChartSimple } from "@fortawesome/pro-regular-svg-icons/faChartSimple"
import { faChartLine } from "@fortawesome/pro-regular-svg-icons/faChartLine"
import { faPercent } from "@fortawesome/pro-regular-svg-icons/faPercent"
import { faDollarSign } from "@fortawesome/pro-regular-svg-icons/faDollarSign"
import { faFeather } from "@fortawesome/pro-regular-svg-icons/faFeather"
import { faUserGroup } from "@fortawesome/pro-regular-svg-icons/faUserGroup"
import { faUserCheck } from "@fortawesome/pro-regular-svg-icons/faUserCheck"
import { faCoffee } from "@fortawesome/pro-regular-svg-icons/faCoffee"
import { faUserPlus } from "@fortawesome/pro-regular-svg-icons/faUserPlus"
import { faBookOpen } from "@fortawesome/pro-regular-svg-icons/faBookOpen"
import { faPlug } from "@fortawesome/pro-regular-svg-icons/faPlug"
import { faTableList } from "@fortawesome/pro-regular-svg-icons/faTableList"
import { faPenToSquare } from "@fortawesome/pro-regular-svg-icons/faPenToSquare"
import { faMessageEdit } from "@fortawesome/pro-regular-svg-icons/faMessageEdit"
import { faCircle } from "@fortawesome/pro-regular-svg-icons/faCircle"
import { faGlobe } from "@fortawesome/pro-regular-svg-icons/faGlobe"
import { faStripe } from "@fortawesome/free-brands-svg-icons/faStripe"
import { faDisplayChartUpCircleDollar } from "@fortawesome/pro-regular-svg-icons/faDisplayChartUpCircleDollar"
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook"
import { faRobot } from "@fortawesome/pro-regular-svg-icons/faRobot"
import { faMapMarkedAlt } from "@fortawesome/pro-regular-svg-icons/faMapMarkedAlt"
import { faHammer } from "@fortawesome/pro-regular-svg-icons/faHammer"
import { faGrid } from "@fortawesome/pro-regular-svg-icons/faGrid"
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons/faMagnifyingGlass"
import { faStars } from "@fortawesome/pro-regular-svg-icons/faStars"
import { faListCheck } from "@fortawesome/pro-solid-svg-icons/faListCheck"
import { faAddressBook } from "@fortawesome/pro-regular-svg-icons/faAddressBook"

import { FeatureIconKey } from "~graphql/generated/types"

const FEATURE_ICON_MAP: Record<FeatureIconKey, IconDefinition> = {
    [FeatureIconKey.Home]: faHome,
    [FeatureIconKey.Calendar]: faCalendarWeek,
    [FeatureIconKey.Bookings]: faCheckSquare,
    [FeatureIconKey.MyOutfitter]: faCompass,
    [FeatureIconKey.Listings]: faList,
    [FeatureIconKey.Contacts]: faAddressBook,
    [FeatureIconKey.Clients]: faUserGroup,
    [FeatureIconKey.Leads]: faUserCheck,
    [FeatureIconKey.Inbox]: faInbox, // Deprecated - kept for GraphQL enum compatibility
    [FeatureIconKey.Quotes]: faPaperPlane,
    [FeatureIconKey.Forms]: faTableList,
    [FeatureIconKey.Coupons]: faPercent,
    [FeatureIconKey.QuickPay]: faDollarSign,
    [FeatureIconKey.Reports]: faChartSimple,
    [FeatureIconKey.Onboardings]: faUserPlus,
    [FeatureIconKey.OnboardingTasks]: faListCheck,
    [FeatureIconKey.Outfitters]: faCompass,
    [FeatureIconKey.OutfitterAutomationSettings]: faRobot,
    [FeatureIconKey.Amenities]: faCoffee,
    [FeatureIconKey.Species]: faFeather,
    [FeatureIconKey.Licenses]: faPenToSquare,
    [FeatureIconKey.Badges]: faCircle,
    [FeatureIconKey.Integrations]: faPlug,
    [FeatureIconKey.KnowledgeBase]: faBookOpen,
    [FeatureIconKey.Templates]: faMessageEdit,
    [FeatureIconKey.PaidAdsReporting]: faDisplayChartUpCircleDollar,
    [FeatureIconKey.PaidFacebookAds]: faFacebook,
    [FeatureIconKey.Stripe]: faStripe,
    [FeatureIconKey.WebsiteBuilder]: faGlobe,
    [FeatureIconKey.WebsiteTracking]: faChartLine,
    [FeatureIconKey.SourceTrips]: faMagnifyingGlass,
    [FeatureIconKey.Auctions]: faGrid,
    [FeatureIconKey.AuctionTrips]: faHammer,
    [FeatureIconKey.MyRegionalDirector]: faMapMarkedAlt,
    [FeatureIconKey.Feedback]: faStars,
}

export function getFeatureIcon(key: FeatureIconKey): IconDefinition {
    return FEATURE_ICON_MAP[key]
}
